"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const assets_1 = require("../../assets");
const styles_1 = require("../../styles");
const BackdropModal_1 = __importDefault(require("../BackdropModal"));
const Button_1 = __importDefault(require("../Button"));
const Card_1 = __importDefault(require("../Card"));
const CardContainer_1 = __importDefault(require("../CardContainer"));
const Text_1 = __importDefault(require("../Text"));
const Status_1 = __importDefault(require("../Status"));
const alertIcon = require('../../../assets/alert.png');
const handleButtons = (buttons, onRequestClose = () => { }) => buttons.map((button) => (react_1.default.createElement(Button_1.default, { key: `alertButton${button.text}`, color: button.color, style: styles.btn, text: button.text, variant: button.variant, onPress: () => {
        onRequestClose();
        button.onPress && button.onPress();
    } })));
const Alert = ({ buttons, notClosableByOutsidePress, severity, onRequestClose, visible, hideBackButton, message, title, }) => {
    const handleAlertIcon = () => {
        if (severity !== 'success') {
            return react_1.default.createElement(react_native_1.Image, { source: alertIcon, style: styles.alertIconStyle });
        }
        return react_1.default.createElement(Status_1.default, { margin: "none", size: 14, verify: true });
    };
    return (react_1.default.createElement(BackdropModal_1.default, { childrenPosition: "center", visible: visible, onRequestClose: () => {
            !notClosableByOutsidePress && onRequestClose && onRequestClose();
        } },
        react_1.default.createElement(Card_1.default, { style: styles.alert },
            react_1.default.createElement(CardContainer_1.default, null,
                react_1.default.createElement(react_native_1.View, { style: styles.titleView },
                    handleAlertIcon(),
                    react_1.default.createElement(Text_1.default, { variant: "title", margin: "none" }, title)),
                react_1.default.createElement(react_native_1.View, { style: styles.seprateLine }),
                react_1.default.createElement(Text_1.default, { style: styles.message, margin: "none" }, message)),
            react_1.default.createElement(react_native_1.View, { style: styles.buttonsContainer },
                !hideBackButton && (react_1.default.createElement(Button_1.default, { color: "secondary", variant: "outlined", style: styles.btn, text: "\u0628\u0627\u0632\u06AF\u0634\u062A", onPress: onRequestClose })),
                handleButtons(buttons, onRequestClose)))));
};
exports.default = Alert;
const styles = react_native_1.StyleSheet.create({
    alert: {
        margin: styles_1.getSpacing(),
    },
    titleView: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: styles_1.getSpacing(),
    },
    alertIconStyle: {
        height: 14,
        width: 14,
        marginRight: styles_1.getSpacing(),
    },
    seprateLine: {
        borderBottomWidth: assets_1.Shape.borderWidth,
        borderColor: styles_1.Colors.border,
    },
    message: {
        marginTop: styles_1.getSpacing(),
    },
    btn: {
        flex: 1,
        marginHorizontal: styles_1.getSpacing(0.5),
    },
    buttonsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: styles_1.getSpacing(0.5),
        marginBottom: styles_1.getSpacing(),
        justifyContent: 'center',
    },
});
